import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ContactService } from '../../core/contact.service';

/**
 * Il form contatti del sito: home, e-ink e soap-mtom lo usano tutte da qui.
 *
 * Prima ogni pagina aveva la sua copia di campi, invio e stili, e ogni modifica
 * andava ripetuta tre volte (l'ultima: il token firmato di contact.api.php).
 * Ora le pagine scelgono solo i testi e se chiedere l'email; titolo e
 * sottotitolo sopra il form restano loro, perché cambiano davvero da pagina a
 * pagina. Lo sfondo scuro lo dà la .cta-section della pagina: gli stili qui
 * contano su testo chiaro.
 */
@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [FormsModule],
  template: `
    <form class="contact-form" (submit)="send($event)">
      <!-- honeypot: nascosto agli umani, compilato dai bot -->
      <input name="website" autocomplete="off" tabindex="-1" aria-hidden="true" class="honeypot" />
      <input    [(ngModel)]="name"  name="name"  [placeholder]="namePlaceholder()" maxlength="100" required />
      @if (askEmail()) {
        <input  [(ngModel)]="email" name="email" placeholder="Email di lavoro" maxlength="150" type="email" required />
      }
      <input    [(ngModel)]="phone" name="phone" placeholder="Telefono (facoltativo)" maxlength="30" type="tel" />
      <textarea [(ngModel)]="message" name="message" [placeholder]="messagePlaceholder()" maxlength="2000" [rows]="rows()" required></textarea>
      <div class="contact-footer">
        @if (status === 'ok') {
          <span class="contact-ok">✦ {{ okText() }}</span>
        } @else if (status === 'error') {
          <span class="contact-err">✗ Errore nell'invio, riprova.</span>
        }
        <button type="submit" [disabled]="sending">
          {{ sending ? 'Invio in corso…' : 'Invia messaggio' }}
        </button>
      </div>
    </form>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact-form.component.scss'
})
export class ContactFormComponent {

  /** Arriva nell'oggetto dell'email: dice da quale pagina scrive la persona. */
  readonly source             = input('');
  /** Con l'email obbligatoria, per le pagine dove si risponde per iscritto. */
  readonly askEmail           = input(false);
  readonly namePlaceholder    = input('Il tuo nome');
  readonly messagePlaceholder = input('Il tuo messaggio');
  readonly rows               = input(4);
  readonly okText             = input('Messaggio inviato! Ti ricontatteremo presto.');

  name    = '';
  email   = '';
  phone   = '';
  message = '';
  sending = false;
  status: 'idle' | 'ok' | 'error' = 'idle';

  constructor(private contact: ContactService) {
    this.contact.prime();
  }

  send(e: Event): void {
    e.preventDefault();
    if (!this.name.trim() || !this.message.trim() || this.sending) return;
    if (this.askEmail() && !this.email.trim()) return;

    this.sending = true;
    this.status  = 'idle';

    this.contact.send({
      name:    this.name.trim(),
      phone:   this.phone.trim(),
      message: this.message.trim(),
      ...(this.askEmail() ? { email: this.email.trim() } : {}),
      ...(this.source()   ? { source: this.source() }    : {}),
    }).subscribe({
      next: () => {
        this.status  = 'ok';
        this.sending = false;
        this.name = this.email = this.phone = this.message = '';
      },
      error: () => {
        this.status  = 'error';
        this.sending = false;
      }
    });
  }
}
